export default __webpack_public_path__ + "static/media/banner4.0deb2601.c0b862fc.jpg";